import {fromJS} from "immutable";
import {createPointLayer} from "../../utils/createPointLayer";
import {createPolygonLayer} from "../../utils/createPolygonLayer";
import {createLineLayer} from "../../utils/createLineLayer";
import {IMapState} from "../types";

export function insertLayer (mapStyle: IMapState['mapStyle'], layerName: string, geoType = '', overrides = {}) {
    let layers = mapStyle.get('layers');
    const index = 150;
    const geotype = geoType.toLowerCase();
    if (geotype === 'point') {
        layers = layers.insert(index + 1, fromJS(createPointLayer(layerName, overrides)));
    } else if (geotype === 'polygon') {
        layers = layers.insert(index, fromJS(createPolygonLayer(layerName, overrides)));
    } else if (geotype === 'line') {
        layers = layers.insert(index, fromJS(createLineLayer(layerName, overrides)));
    }
    mapStyle = mapStyle.set('layers', layers);
    return mapStyle;
}